import { Controller } from "@hotwired/stimulus"

// Attach to a <turbo-frame> to re-fetch it on an interval (Today's Performance
// card). Skips ticks while the tab is hidden so a backgrounded dashboard
// doesn't keep hitting the server, and refreshes immediately when the user
// comes back to a tab that missed a tick.
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 60000 }
  }

  connect() {
    this.missedTick = false
    this.onVisible = () => {
      if (!document.hidden && this.missedTick) this.refresh()
    }
    document.addEventListener("visibilitychange", this.onVisible)
    this.timer = setInterval(() => this.refresh(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
    document.removeEventListener("visibilitychange", this.onVisible)
  }

  refresh() {
    if (document.hidden) {
      this.missedTick = true
      return
    }

    this.missedTick = false
    if (this.element.src) {
      this.element.reload()
    } else {
      this.element.src = this.urlValue
    }
  }
}
